import { render, staticRenderFns } from "./SlPhModuleOnlyToggle.vue?vue&type=template&id=92724e92"
import script from "./SlPhModuleOnlyToggle.vue?vue&type=script&lang=ts"
export * from "./SlPhModuleOnlyToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports